// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedPlans = [], children }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userPlan = userData?.plan_name;

  if (!allowedPlans.includes(userPlan)) {
    return (
      <Navigate
        to="/subscription"
        replace
        state={{
          fromRestrictedAccess: true,
          message: "You need to upgrade to Pro or Enterprise Plan to access this feature.",
        }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
